module.exports = __webpack_public_path__ + "img/sol_isol_pain1.068a5376.png";